<div class="" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
  <button (click)="addRow()" [disabled]="isDisabled" mat-raised-button type="button">
    + Hinzufügen
  </button>
  @if (showSave) {
    <button
      (click)="save.emit()"
      [disabled]="formArray.invalid"
      color="accent"
      mat-raised-button
      type="button"
      >
      <mat-icon>save</mat-icon>
      Speichern
    </button>
  }
</div>
<table [dataSource]="formArray.controls" class="width-match-parent" mat-table>
  @for (col of config; track col) {
    <ng-container [matColumnDef]="col.key">
      <th *matHeaderCellDef mat-header-cell>{{ col.label ?? '' }}</th>
      <td
        *matCellDef="let group; let i = index"
        [formGroup]="group"
        class="p-r-2"
        mat-cell
        style="vertical-align: top"
        >
        @if (col.type === 'string') {
          <mat-form-field
            appearance="fill"
            class="width-match-parent"
            >
            <input [formControlName]="col.key" matInput />
            <mat-label>{{ col.label }}</mat-label>
          </mat-form-field>
        }
        @if (col.type === 'selection-list') {
          <recrewt-chip-editor [formControlName]="col.key"
            [optionTpl]="optionTpl"
            [predefinedOnly]="true"
            [predefined]="col.options"
            labelKey="value"
           />
        }
        <ng-template #optionTpl let-option> {{ option.value }}</ng-template>
        @if (col.type === 'list') {
          <recrewt-chip-editor [formControlName]="col.key"
            labelKey="value"
           />
        }
      </td>
    </ng-container>
  }

  <ng-container matColumnDef="actions">
    <th *matHeaderCellDef mat-header-cell></th>
    <td *matCellDef="let group; let i = index" class="p-1" mat-cell>
      <button (click)="removeRow(i)" [disabled]="isDisabled" mat-icon-button type="button">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns" />
  <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
</table>
